import { useMutation } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC implementation of recalculateRiskScores (RSP-6156). The mutation takes
 * no input; `mutateAsync` resolves once the async request completes (the
 * data-layer emits the trigger, event-consumers recomputes, and the
 * RiskScoresRecalculated completion event closes the request-state-api request).
 */
export const useRecalculateRiskScoresTRPC = () => {
  const trpc = useTRPC();
  const mutation = useMutation({
    ...trpc.frontend.aggregation.recalculateRiskScores.mutationOptions(),
  });

  return {
    recalculateRiskScores: async () => mutation.mutateAsync(undefined),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
